





























































import { Component, Vue } from 'vue-property-decorator';
import { mapGetters } from 'vuex';
import { Actions, Mutations } from '@/ts/store/Constants';
import PreviewDocument from '@/components/Admin/Panels/PreviewDocument.vue';
import VacantUnits from '@/components/Admin/Lists/VacantUnits.vue';
import InProgressOffers from '@/components/Admin/Lists/InProgressOffers.vue';
import DeadlineOffers from '@/components/Admin/Lists/DeadlineOffers.vue';
import SentOffers from '@/components/Admin/Lists/SentOffers.vue';
import CompletedOffers from '@/components/Admin/Lists/CompletedOffers.vue';
import ClosedOffers from '@/components/Admin/Lists/ClosedOffers.vue';
import TemplateRenderer from '@/components/Admin/Panels/TemplateRenderer.vue';
import ProjectsData from '@/ts/ProjectsData';
import DownloadOfferReportForm from '@/components/Admin/Forms/DownloadOfferReportForm.vue';

@Component({
    components: {
        PreviewDocument,
        VacantUnits,
        InProgressOffers,
        DeadlineOffers,
        SentOffers,
        CompletedOffers,
        ClosedOffers,
        TemplateRenderer,
        DownloadOfferReportForm,
    },
    computed: {
        ...mapGetters({
            presentationType: 'PresentationFlows/getPresentationType',
            presentationHeader: 'PresentationFlows/getPresentationHeader',
            templateRendererOverlayVisibility: 'TemplateRenderer/getTemplateRendererOverlayVisibility',
        }),
    },
})
export default class PresentationFlows extends Vue {
    public currentSelectedProject: any = 'all';
    public showDownloadOfferReport: boolean = false;
    public tabs: any[] = [
        {
            title: 'All vacant units',
            translations_key: 'all',
            status: true,
            requestOption: 'all',
        },
        {
            title: 'In progress offers',
            translations_key: 'progress',
            status: false,
            requestOption: 'progress',
        },
        {
            title: 'Deadline reached',
            translations_key: 'deadline-reached',
            status: false,
            requestOption: 'deadline',
        },
        {
            title: 'Sent offers',
            translations_key: 'sent-offers',
            status: false,
            requestOption: 'sent',
        },
        {
            title: 'Won - completed',
            translations_key: 'won-completed',
            status: false,
            requestOption: 'completed',
        },
        {
            title: 'Lost - declined',
            translations_key: 'lost-declined',
            status: false,
            requestOption: 'declined',
        },
    ];

    constructor() {
        super();
    }

    get projects(): ProjectsData[] {
        return this.$store.getters['Projects/allProjects'];
    }

    public togglePresentationFlowTab(tabIndex: any) {
        if (!this.tabs[tabIndex].status) {
            this.$store.dispatch(Actions.TOGGLE_PRESENTATION_FLOW_TAB, {
                option: this.tabs[tabIndex].requestOption,
                title: this.tabs[tabIndex].title,
            });

            this.tabs.forEach((tab) => tab.status = false);
            this.tabs[tabIndex].status = true;
            this.$store.commit(Mutations.SET_CURRENT_EDIT_PRESENTATION, []);
            this.$store.commit(Mutations.RESET_ALL_MODAL_VISIBILITY);
        }
    }

    public setCurrentProject() {
        const presentationTab = this.$store.getters['PresentationFlows/getPresentationType'];
        const projectPayload  = {project: this.currentSelectedProject};

        this.$store.commit(Mutations.SET_CURRENT_PROJECT, this.currentSelectedProject);

        console.log(presentationTab);

        switch (presentationTab) {
            case 'progress':
                this.$store.dispatch(Actions.FETCH_ALL_INPROGRESS_OFFERS, projectPayload);
                break;
            case 'deadline':
                this.$store.dispatch(Actions.FETCH_ALL_DEADLINE_OFFERS, projectPayload);
                break;
            case 'sent':
                this.$store.dispatch(Actions.FETCH_ALL_SENT_OFFERS, projectPayload);
                break;
            case 'completed':
                this.$store.dispatch(Actions.FETCH_ALL_COMPLETED_OFFERS, projectPayload);
                break;
            default:
                this.$store.dispatch(Actions.FETCH_ALL_VACANT_UNITS, projectPayload);
        }
    }

    public created() {
        this.$store.dispatch(Actions.FETCH_ALL_WAITING_LISTS);
        this.$store.commit(Mutations.SET_PRESENTATION_TYPE, 'all');
    }
}
